export var LiveRegionRole;

(function (LiveRegionRole) {
  LiveRegionRole["Status"] = "status";
  LiveRegionRole["Log"] = "log";
})(LiveRegionRole || (LiveRegionRole = {}));